export default {
    state: {
        // decisionTab: null, // 拓店0,踩点1
        decisionType: null,
    },
    actions: {},
    mutations: {
        // DECISION_TAB(state: DicisionState, val: number) {
        //   state.decisionTab = val;
        // },
        DECISION_TYPE: function (state, val) {
            state.decisionType = val;
        }
    },
    getters: {}
};
